import cn from "clsx";
import { Drawer } from "@crehana/ui";
import { useMainMenuContext } from "../hooks";
import DrawerHeader from "./DrawerHeader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MainMenuDrawer = function MainMenuDrawer(_ref) {
  var title = _ref.title,
    isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss,
    onGoBack = _ref.onGoBack,
    position = _ref.position,
    children = _ref.children,
    isNew = _ref.isNew,
    className = _ref.className;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme;
  return /*#__PURE__*/_jsxs(Drawer, {
    open: isOpen,
    onDismiss: onDismiss,
    position: position,
    className: cn(className, 'flex flex-col flex-no-wrap h-full', theme.submenu.backgroundColorClassName, theme.submenu.textColorClassName),
    width: theme.submenu.drawerWidth,
    backdropStyles: {
      opacity: 0
    },
    children: [/*#__PURE__*/_jsx(DrawerHeader, {
      title: title,
      onDismiss: onDismiss,
      onGoBack: onGoBack,
      isNew: isNew
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-col flex-1 h-full overflow-auto",
      children: children
    })]
  });
};
export default MainMenuDrawer;